import '../../styles/principal/header.css';
import React, { useState, useEffect } from 'react';
import { Navbar, Button } from 'react-bootstrap';
import { Redirect, Switch, Route, useLocation } from 'react-router-dom';
import Login from '../../pages/login';
import Copyright from './copyright';
import Transcribe from '../../pages/transcribe';
import logocnc from '../../img/logo-cnc.png'
import { useLoading } from '../../contexts/LoadingContext';
import { toast } from 'react-toastify';
import useGetResolution from '../../functions/useGetResolution';
import TranscribeNotes from '../transcribe-notes';

const Header = () => {
  const location = useLocation();
  const [pathname, setPathname] = useState(location.pathname);
  const paths = [
    "/transcripciones/inicio-sesion",
    "/transcripciones/transcribir",
  ];
  const [auth, setAuth] = useState(localStorage.getItem("auth"));
  const [accessToken, setAccessToken] = useState(localStorage.getItem("token"));
  const apiUrl = process.env.REACT_APP_API_URL;
  const { setLoading } = useLoading();
  const resolution = useGetResolution();

  useEffect(() => {
    setPathname(location.pathname);
  }, [location]);

  // const validateToken = async () => {
  //     let ok = true;
  //     if (auth) {
  //         const res = await fetch(`${apiUrl}/validate-token`, {
  //             headers: { 'x-access-tokens': accessToken },
  //         })
  //         await res
  //             .json()
  //             .then(d => {
  //                 if (d['message'] !== 'token is valid') {
  //                     logout();
  //                     ok = false;
  //                 }
  //             });
  //     }
  //     return ok;
  // }
    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("auth");
        localStorage.removeItem("username");
        console.log(accessToken);
        setAccessToken("");
        setAuth(false);
        toast.info("La sesión ha sido cerrada");
    };
  
  const loginfn = async (user, password) => {
    setLoading(true);
    // const res = await fetch(`${apiUrl}/login/`, {
    // const res = await fetch(`http://localhost:8000/api/login/`, {
    const res = await fetch(`https://transcripciones.cnccol.com/api/login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username: user,
        password: password,
      }),
    });
    if (res.ok) {
      res.json().then((d) => {
        localStorage.setItem("token", d["token"]);
        localStorage.setItem("auth", true);
        localStorage.setItem("username", user);
        setAccessToken(d["token"]);
        setAuth(true);
        toast.success("Sesión iniciada correctamente");
      });
    } else {
      toast.error("Los datos de usuario y contraseña son incorrectos.");
    }
    setLoading(false);
  };

    return (
        <div className="header">
            {
                <Navbar className='navbar-shadow flex row-auto' bg='dark' variant='dark'>
                    <img
                        src={logocnc}
                        alt='cnc-logo'
                        className='cnc-logo'
                    />
                    <Navbar.Brand className='header-title flex items-center global-font'>TRANSCRIPCIONES</Navbar.Brand>
                    {
                        auth ?
                            (resolution === "lg" || resolution === "md") && (
                                <div className="navbar-component ml-auto flex items-center">
                                    <div className="dropdown dropdown-end bg-transparent">
                                        <div tabIndex={0} role="button" className="btn m-1">
                                            <svg
                                            className="swap-off fill-current"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="32"
                                            height="32"
                                            viewBox="0 0 512 512">
                                            <path d="M64,384H448V341.33H64Zm0-106.67H448V234.67H64ZM64,128v42.67H448V128Z" />
                                        </svg></div>
                                        <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[5] w-52 p-2 shadow">
                                            <li><a className='text-black' onClick={() => document.getElementById('my_modal_4').showModal()}>Notas</a></li>
                                            <li><a className='text-black' onClick={() => { logout() }}>Cerrar sesión</a></li>
                                        </ul>
                                    </div>
                                </div>
                            )

                            :
                            null
                    }
                <dialog id="my_modal_4" className="modal">
                    <div className="modal-box">
                        <form method="dialog">
                            <button className="btn btn-sm btn-circle absolute right-1 top-1">✕</button>
                        </form>
                        <TranscribeNotes/>
                    </div>
                </dialog>
                </Navbar>
            }
            <Redirect to={auth ? (paths.slice(1).includes(pathname) ? pathname : paths[1]) : paths[0]} />
            <div className='pruenan'>
                <Switch>
                    <Route exact path={paths[0]}>
                        <Login login={loginfn} />
                        <Copyright />
                    </Route>
                    <Route exact path={paths[1]}>
                        {auth ? (
                            <>
                                <Transcribe
                                    setAuth={setAuth}
                                />
                                {(resolution === "lg" || resolution === "md") && <div className='prueba'><Copyright /></div>}
                            </>
                        ) : (
                            <Redirect to={paths[0]} />
                        )}
                    </Route>
        </Switch>
      </div>
    </div>
  );
};

export default Header;
